export default __webpack_public_path__ + "static/media/YanetLovelace.05813738.png";